/*
 * Ensures the skip link actually moves focus to #MainContent.
 * Browsers fall back to focusing <body> when the anchor target
 * isn't itself focusable, so we focus it explicitly on activation.
 */
document.addEventListener('click', function (event) {
  const link = event.target.closest('.skip-link');
  if (!link) return;

  const targetId = link.getAttribute('href').replace('#', '');
  const target = document.getElementById(targetId);
  if (!target) return;

  target.focus();
});
